import React from 'react';
import {LayoutMenuState} from "../../../layout/layout/const";

type Props = {
    skin            : string,
    type?           : 'minimize'|'expand',
    onToggleClick   : callback,
    className?      : string
}


export default function MinimizeButton(props:Props) {

    if (!gd.ui.isMinimizeMenuAllowed) return null;

    let type
    if (props.type) {
        type = props.type
    } else {
        type = gd.layout.menuState === LayoutMenuState.STATIC ? 'minimize' : 'expand'
    }

    const classes = Classes("gd-minimize-button", type+"-type", props.skin+"-skin", props.className, {
        "i5-big-angle-left"    : type === 'minimize',
        "i5-big-angle-right"   : type === 'expand'
    });

    return <div className={classes} onClick={props.onToggleClick}/>;
}


